







































































import { defineComponent, reactive, toRefs, onMounted, computed, onBeforeUnmount } from '@vue/composition-api'
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import SaitenEditTab from "../../components/SaitenEditTab.vue"
import DropArea from "../../components/DropArea.vue";
import AlertArea from "../../components/AlertArea.vue";
import { BaseSheet, BaseSheetField }from  "../../modules/teacher/FieldEdit"

export interface Data {
  tabNo: number;
  base_sheet_id: string;
  baseSheet: BaseSheet | null;
  baseSheetFields: BaseSheetField[];
  errors: string[];
  isChangeSheetFields: boolean;
}

export default defineComponent({
  components: {
    "saiten-edit-tab": SaitenEditTab,
    "drop-area": DropArea,
    "alert-area": AlertArea,
  },
  setup(props, context){

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      tabNo: 1,
      base_sheet_id: "",
      baseSheet: null,
      baseSheetFields: new Array<BaseSheetField>(),
      errors: [],
      isChangeSheetFields: false,
    });

    /************************************************************
     * 種別が設問のリスト
     ************************************************************/

    const questionBaseSheetFields = computed(() => {
      return state.baseSheetFields.filter(x => x.kind == 0);
    });

    /************************************************************
     * 合計点
     ************************************************************/

    const totalAllot = computed(() => {
      return Common.sumArray(state.baseSheetFields.filter(x => x.kind == 0).map(x => typeof x.allot === "string" ? parseInt(x.allot) : x.allot));
    });

    /************************************************************
     * テンプレートダウンロード
     ************************************************************/

    const downloadFieldTemplate = async (): Promise<void> => {
      window.location.href = `/api/field_edit/download_field_template`;
    };
    
    /************************************************************
     * エクセルアップロード
     ************************************************************/

    const upload = async (file: any) => {
      let fd = new FormData();
      fd.append('upload[file]', file);

      if(!window.confirm("ファイルをアップロードします。\n既に採点情報が存在する場合、採点情報は削除されます。\n実行してよろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay", "ファイル読み込み中");

      await http.post(`/api/field_edit/upload/${state.base_sheet_id}`, fd).then(response => {
        state.baseSheet = response.data.base_sheet_hash;
        state.baseSheetFields = response.data.base_sheet_hash.base_sheet_fields;

        alert("アップロードが完了しました。");
        state.errors = [];
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /************************************************************
     * 保存
     ************************************************************/

    const saveClick = async () => {

      if(!window.confirm("問題構造を保存します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay", "ファイル読み込み中");
      
      await http.patch(`/api/field_edit/${state.base_sheet_id}`, {base_sheet_fields: questionBaseSheetFields.value, is_change_sheet_fields: state.isChangeSheetFields}).then(response => {
        alert("処理が完了しました。");
        context.root.$router.push(`/teacher_site/correct_image_upload/${state.base_sheet_id}`).catch(err => {});
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /************************************************************
     * 設問追加削除
     ************************************************************/

    const addSheetFields = (idx: number): void => {

      if (!window.confirm(`設問を追加します。\n既に採点情報が存在する場合、保存ボタン押下時に採点情報は削除されます。\n実行してよろしいですか？`)) {
        return;
      }

      state.isChangeSheetFields = true;

      // 設問追加
      const questionBaseSheetFields = state.baseSheetFields.filter(x => x.kind == 0);
      questionBaseSheetFields.splice(idx, 0, new BaseSheetField({id: 0, kind: 0, part1: null, part2: null, part3: null, allot: 0, page: 1}));

      state.baseSheetFields = state.baseSheetFields.filter(x => x.kind != 0).concat(questionBaseSheetFields);
    };

    const removeSheetFields = (idx: number): void => {

      if (!window.confirm(`設問を削除します。\n既に採点情報が存在する場合、保存ボタン押下時に採点情報は削除されます。\n実行してよろしいですか？`)) {
        return;
      }

      state.isChangeSheetFields = true;

      // 設問削除
      const questionBaseSheetFields = state.baseSheetFields.filter(x => x.kind == 0);
      questionBaseSheetFields.splice(idx, 1);

      state.baseSheetFields = state.baseSheetFields.filter(x => x.kind != 0).concat(questionBaseSheetFields);
    };

    /************************************************************
     * onMounted
     ************************************************************/

    onMounted(async () => {
      context.root.$store.commit("setIsHeaderDisp", false);
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      state.base_sheet_id = context.root.$route.params.base_sheet_id;

      // APIで登録済み試験情報取得
      await http.get(`/api/field_edit?base_sheet_id=${state.base_sheet_id}`).then(response => {
        state.baseSheet = response.data.base_sheet_hash;
        state.baseSheetFields = response.data.base_sheet_hash.base_sheet_fields.map((x: any) => new BaseSheetField(x));
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
        }
        context.root.$store.dispatch("goBaseSheetList");
      });

      context.root.$store.dispatch("hideOverlay");
    });

    /******************************
     * Before Unmount
     ******************************/

    onBeforeUnmount(async () => {
      context.root.$store.commit("setIsHeaderDisp", true);
    });

    return {
      ...toRefs(state),
      questionBaseSheetFields,
      totalAllot,
      downloadFieldTemplate,
      upload,
      saveClick,
      addSheetFields,
      removeSheetFields,
    };
  }
})
